// extracted by mini-css-extract-plugin
module.exports = {"root":"Chat_root__2YHco","messages":"Chat_messages__1oZUa","dateDivider":"Chat_dateDivider__2L_6g"};